module.exports = new __parcel__URL__("contact_address_icon.e1874873.svg").toString();